/**
 * The speeds the players offer (product owner, 2026-10-28). The one chosen is a preference of the
 * person, kept on the server: it is in force on every video, not set again on each one.
 */
export const PLAYBACK_RATES = Object.freeze([0.25, 0.5, 0.75, 1, 1.25, 1.5, 2] as const);

export type PlaybackRate = (typeof PLAYBACK_RATES)[number];

export const DEFAULT_PLAYBACK_RATE: PlaybackRate = 1;

export function isPlaybackRate(value: unknown): value is PlaybackRate {
  return (PLAYBACK_RATES as readonly unknown[]).includes(value);
}
